import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./config";

let messaging = null;
let unsubscribe = null;

// ================= INIT =================
if (typeof window !== "undefined") {
  try {
    messaging = getMessaging(app);
    console.log("🔥 Messaging initialized");
  } catch (err) {
    console.log("❌ Messaging init failed:", err);
  }
}

// ================= REQUEST PERMISSION + TOKEN =================
export const requestPermission = async () => {
  try {
    if (!messaging) return null;

    if (!("Notification" in window)) {
      console.log("❌ Notifications not supported");
      return null;
    }

    const permission = await Notification.requestPermission();

    console.log("🔔 Permission:", permission);

    if (permission !== "granted") return null;

    // ================= SERVICE WORKER =================
    let registration = null;

    if ("serviceWorker" in navigator) {
      try {
        registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

        await navigator.serviceWorker.ready;
        console.log("✅ SW ready");
      } catch (err) {
        console.log("❌ SW error:", err);
      }
    }

    // ================= TOKEN =================
    const token = await getToken(messaging, {
      vapidKey:
        "BPLkFMSfbQbpVWOh_shHAAL9UwhT7yy1aW_rU6ERypvv1E_6V0WjqETz01NUQpofurL9OmTKe0aLp4t7YrCPyuw",
      serviceWorkerRegistration: registration || undefined,
    });

    console.log("🔥 FCM TOKEN:", token);

    if (token) {
      localStorage.setItem("fcmToken", token);
    }

    return token;
  } catch (error) {
    console.log("❌ FCM ERROR:", error);
    return null;
  }
};

// ================= FOREGROUND LISTENER =================
export const listenMessages = (callback) => {
  if (!messaging) {
    console.log("❌ Messaging not ready");
    return () => {};
  }

  console.log("📡 Foreground listener attached");

  // ❌ prevent multiple listeners
  if (unsubscribe) {
    console.log("⚠️ Listener already running");
    return unsubscribe;
  }

  unsubscribe = onMessage(messaging, (payload) => {
    console.log("📩 Firebase RAW:", payload);

    const title =
      payload?.notification?.title ||
      payload?.data?.title ||
      "Notification";

    const body =
      payload?.notification?.body ||
      payload?.data?.body ||
      "";

    const notificationData = {
      title,
      body,
      raw: payload,
    };

    console.log("🔥 Parsed Notification:", notificationData);

    if (typeof callback === "function") {
      callback(notificationData);
    }
  });

  // ================= CLEANUP =================
  return () => {
    console.log("🧹 Removing listener");

    if (unsubscribe) {
      unsubscribe();
      unsubscribe = null;
    }
  };
};

export default messaging;